import { Component, OnInit } from '@angular/core';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { HttpClient } from '@angular/common/http';
import { CUtilit, ModalUtilit } from 'src/app/classes/utilit';
import { MatDialog } from '@angular/material/dialog';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';
import { CST_LIST_REFRESH_DISPOTITION, CST_TOOLBAR_BTN_EVENT } from 'src/app/components/toolbar/app-tool-bar/app-tool-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-session-manager-page',
  templateUrl: './session-manager-page.component.html',
  styleUrls: ['./session-manager-page.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class SessionManagerPageComponent implements OnInit {

  lockInterface: boolean; // Doit bloquer tout les bouton coté html ce composant
  inLoading: boolean;     // Permet d'afficher un indiquateur de chargement
  sessionInfo: SessionInfo[] = [];
  columnsToDisplay = ['ID', 'LifeDuration', 'SessionName', 'StartDateTime', 'Status', 'Connected ?', 'Action'];
  expandedElement: SessionInfo | null = null;

  // Todo: identifier sa propre session

  constructor(
    private mToolbar: AppToolbarService,
    private mhttp: HttpClient,
    private mDialog: MatDialog,
    private mSnackBar: MatSnackBar
  ) {
    this.lockInterface = false;
    this.inLoading = false;
  }

  ngOnInit(): void {
    this.mToolbar.setDisposition(CST_LIST_REFRESH_DISPOTITION);
    this.mToolbar.getObservableClick(true).subscribe(next => this.onToolbatClick(next));
    this.loadSessionInfo().catch(console.error);
  }

  async loadSessionInfo() {
    this.lockInterface = true;
    this.inLoading = true;
    try {
      this.sessionInfo = (await ArmaServConnection.aGET(this.mhttp, 'GetListSession', ['password'])).result[0];
    } finally {
      this.lockInterface = false;
      this.inLoading = false;
    }
  }

  onToolbatClick(value: any) {
    if (value == CST_TOOLBAR_BTN_EVENT.Refresh) {
      this.loadSessionInfo().catch(console.error);
    }
  }

  toObjectInterface(element: any): any {
    return Object.entries(element);
  }

  async closeSession(event: MouseEvent , sessionInfo: SessionInfo) {
    event.stopPropagation(); // Pour eviter de déclencher l'event sur le tableau
    let closeOK = false;
    this.lockInterface = true;
    try {
      // Message de confirmation pour fermer la session

      if (await ModalUtilit.warModal2btn(this.mDialog, 'This will disconect user, continue ?')) {
        closeOK = await ArmaServConnection.closeSession(this.mhttp, sessionInfo.SessionName);
        if (closeOK) {
          closeOK = true;
          CUtilit.showSnackBar(this.mSnackBar, undefined, 'Successful', 'Fermer', 5).catch(console.error);
        } else {
          console.error('Error while closing session');
          CUtilit.showSnackBar(this.mSnackBar, undefined, 'Error while closing session', 'Fermer', 5).catch(console.error);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.lockInterface = false;
      // Re actualise la liste des sessions
      if (closeOK) this.loadSessionInfo().catch(console.error);
    }
  }
}

export interface SessionInfo {
  ID: number;
  LifeDuration: number;
  SessionName: string;
  StartDateTime: string;
  Status: string;
  LoggedUser: {IsConnected: boolean} | any;
}
